<template>
  <div :class="getClass" @click="$emit('click')">
        <div class="ileftColumn">
            <label  class="ilabelBold">
                {{topLeft}} 
            </label>
            
        </div>
        <div class="irightColumn" v-if="showRight">
             <div class="" v-if="imageFilename!=null">
                <img alt="product image" :src="getImageForBar"   :class="imgdivclass" >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"lookupresult_image",
    props:{
        topLeft:{
            type:String,
            required:true
        },
        bottomLeft:{
            type:String,
        },
        topRight:{
            type:String,
        },
        bottomRight:{
            type:String,
        },
        showborder:{
            type:String,
            default:'false'
        },
        showRight:{
            type:String,
            default:'false'
        },
        selected:{
            type:Boolean,
            default:false
        },
        inactive:{
            type:Boolean,
            default:false
        },
        imageFilename:{
            type:String,
            
        }
    },
    data() {
        return {
           
        };
    },
    methods:{
   

    },
    computed:{
        getClass(){
            var thisclass='iitem'
            if(this.inactive){thisclass='iinactiveitem'}
            if(this.selected){
                thisclass="iselecteditem"
                if(this.inactive){thisclass='iinactiveselecteditem'}
            }
            if(this.showborder=='true'){
                thisclass= thisclass + " borderedge"
            }
            return thisclass
        },
        imgdivclass(){
            if(this.selected){return "imgdivsel"}
            else{return "imgdiv"}
        },
        getImageForBar(){
       
                if(this.imageFilename==null){return null}
                    var imgBasePath =  window.VUE_CONFIG_API + 'personimage/'

                var fn = this.imageFilename
                var splitfn=fn
                const lastDot = fn.lastIndexOf('.');
                if (lastDot > 0) {
                splitfn= fn.slice(0, lastDot) + '/' + fn.slice(lastDot + 1);
                }

                    return imgBasePath + splitfn
            },
    }
}
</script>

<style  >
.iitem{
    font-size:medium;
    background-color: white;
    border-radius:0px;
    margin:5px 0px 5px 0px;
    padding:10px;
    display:grid;
    grid-template-columns: auto 50px;
    vertical-align: middle;
}
.iselecteditem{
    font-size:large;
    border-style:solid;
    border-color:var(--button-color);
    border-width: 4px;
    background-color: white;
    border-radius:0px;
    margin:5px 0px 5px 0px;
    padding:10px;
    display:grid;
    grid-template-columns: auto 50px;
    vertical-align: middle;
}

.iinactiveitem{
 font-size:medium;
    background-color: gray;
    border-radius:0px;
    margin:5px 0px 5px 0px;
    padding:10px;
    display:grid;
    grid-template-columns: auto 50px;
}
.iinactiveselecteditem{
    font-size:large;
    border-style:solid;
    border-color:var(--button-color);
    border-width: 4px;
    background-color: gray;
    border-radius:0px;
    margin:5px 0px 5px 0px;
    padding:10px;
    display:grid;
    grid-template-columns: auto 50px;
}

.borderedge{
    border-style:inset;
    border-color:var(--border-color);
    border-width: .5px;
}
.ileftColumn{
    display: flex;
  align-items: center; /* vertical centering */
    text-align: left;
}
.irightColumn{
   display: flex;
  align-items: center; /* vertical centering */
    text-align: right;
}
.ilabelBold{
  /* font-size:medium; */
  font-weight: bold;
}
.ilabel{
    /* font-size:medium; */
}
.imgdiv{
    width:30px;
    margin:0px;
}
.imgdivsel{
    width:45px;
    margin:0px;
}
</style>
